import React from 'react';

function PillComponent({ question, label }) {
  return <>{label || question.Text}</>;
}

export default PillComponent;
